/**
 * Use these header heights if you need to visually center content
 */

export const HEADER_HEIGHT_MD_LG = "72px";
export const HEADER_HEIGHT_SM = "64px";
export const HEADER_HEIGHT_XS = "56px";
